// 3rd party imports
import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { UserAuthStore } from 'stores';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { UserInfo } from 'models';

interface ZendeskSsoExecutorProps extends RouteComponentProps {
  userAuth?: UserAuthStore;
}

@inject('userAuth')
@observer
class ZendeskSsoComponent extends React.Component<ZendeskSsoExecutorProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    if (this.props.userAuth) {
      const userInfo: UserInfo = this.props.userAuth.currentUser;

      if (!userInfo) {
        return null;
      }

      fetch('/api/v1/zendesk/access/signin', {
        method: 'POST',
        redirect: 'follow',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: userInfo.given_name,
          email: userInfo.email,
          urlSearch: this.props.location.search,
        }),
      }).then((res) =>
        res.json().then((json) => {
          window.location.href = json.location;

          return null;
        }),
      );
    }

    return null;
  }
}

export const ZendeskSsoExecutor = withRouter(ZendeskSsoComponent);
